/** @format */

import { RewardType, RewardUnit } from "interfaces";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Button, Form, Input, Label } from "semantic-ui-react";
import { api } from "services";
interface LuckyWheel {
  base_cost: number;
  increase_cost_rate: number;
  rewards: LuckyWheelReward[];
}
interface LuckyWheelReward {
  rewardId: Number;
  groupId: string;
  rewards: RewardType;
  amount: Number;
  unit: RewardUnit;
  freeGoldWeight: Number;
  freGoldRate: Number;
  mstrWeight: Number;
  mstrRate: Number;
  canX2: boolean;
}
export default function LuckyWheelConfig() {
  const [data, setData] = useState<LuckyWheel>(null);
  const [entity, setEntity] = useState(null);
  useEffect(() => {
    async function loadConfig() {
      let rs = await api.post("/operation/api/get-config", {
        where: { name: "LUCKY_WHEEL_CONFIG" },
      });
      setEntity(rs.data[0]);
      setData(JSON.parse(rs.data[0].value));
    }
    loadConfig();
  }, []);
  function onChange(name: string, value: any) {
    console.log("onchange ", data);
    let tmp: any = _.cloneDeep(data);
    tmp[name] = value;
    setData(tmp);
  }
  async function save() {
    console.log("data", data);
    entity.value = JSON.stringify(data);
    let rs = await api.post("/operation/api/update-config", entity);
    alert("Success");
  }
  return (
    <div>
      <div className="flex justify-between">
        <p className="text-3xl font-semibold">Lucky Wheel</p>
        <Button
          icon="check"
          content="Save"
          color="blue"
          onClick={() => {
            save();
          }}
        />
      </div>
      {data ? (
        <Form>
          <div className="flex gap-2">
            <Form.Field>
              <label>Base Cost</label>
              <Input
                type="text"
                value={data.base_cost}
                onChange={(evt: any) => {
                  onChange("base_cost", Number(evt.target.value));
                }}
              />
            </Form.Field>
            <Form.Field>
              <label>Increase Cost Rate</label>
              <Input
                type="text"
                value={data.increase_cost_rate}
                onChange={(evt: any) => {
                  onChange("increase_cost_rate", Number(evt.target.value));
                }}
              />
            </Form.Field>
          </div>
        </Form>
      ) : (
        <div>
          <p>Loading...</p>
        </div>
      )}
    </div>
  );
}
